import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { CmsEntities } from 'client/data/models/cms';
import { ScrollElement } from 'site-modules/shared/components/scroll-link/scroll-element';
import { VehicleCard } from 'site-modules/editorial/components/best/vehicle-card/vehicle-card';
import { ResearchEntry } from 'site-modules/editorial/components/best/research-entry/research-entry';

const CARD_RENDER_TYPE = 'card';

export function VehiclesSection({ entry, entriesProps, onSelectCar, selectedCars, isMobile = false }) {
  const anchorName = entry.metadata('anchorName').value();
  const cardTitle = entry.metadata('card-title').value();
  const isNumbered = entry.metadata('isNumbered').boolean();

  const children = entry.children();
  const vehicleNumbers = useMemo(
    () =>
      children.reduce((acc, sectionEntry) => {
        const isCard = sectionEntry.metadata('renderType').value() === CARD_RENDER_TYPE;
        const lastCount = acc.length > 0 ? acc[acc.length - 1] : 0;
        acc.push(isCard ? lastCount + 1 : lastCount);
        return acc;
      }, []),
    [children]
  );

  return (
    <ScrollElement id={anchorName} className="vehicle-section pos-r">
      <h2 className="heading-3 mb-1 mb-md-1_5">{cardTitle}</h2>
      <ol className="p-0" style={{ listStyle: 'none' }}>
        {children.map((sectionEntry, index) => {
          const key = `${entry.id}-${sectionEntry.id}-${index}`;

          if (sectionEntry.metadata('renderType').value() === CARD_RENDER_TYPE) {
            return (
              <VehicleCard
                key={key}
                onSelectCar={onSelectCar}
                selectedCars={selectedCars}
                entry={sectionEntry}
                number={isNumbered ? vehicleNumbers[index] : null}
                isMobile={isMobile}
                componentToUse="li"
                index={index}
              />
            );
          }

          return (
            <ResearchEntry
              key={key}
              entry={sectionEntry}
              entriesProps={entriesProps}
              hasSeparator={false}
              isMobile={isMobile}
              componentToUse="li"
            />
          );
        })}
      </ol>
    </ScrollElement>
  );
}

VehiclesSection.propTypes = {
  entry: CmsEntities.Content.isRequired,
  onSelectCar: PropTypes.func.isRequired,
  selectedCars: PropTypes.arrayOf(PropTypes.object).isRequired,
  entriesProps: PropTypes.shape({
    title: PropTypes.string,
    canonical: PropTypes.string,
    pathname: PropTypes.string,
  }).isRequired,
  isMobile: PropTypes.bool,
};
